<template>
  <div v-if="hasOwner" class="pdf-options">
    <h5>
      {{
        i18n.t(
          additionalQuote ? '/additionalorder/printadditionalorder' : '/PrintOptions/BlockTitle'
        )
      }}
    </h5>
    <form class="pdf-options-row" @submit.prevent="submit">
      <app-fieldset title="print-options" css-class="pdf-front-page">
        <app-form-field
          :id="`${quoteNamespace}_pdfOptionsContractor`"
          :title="i18n.t('/PrintOptions/ContractorLabel')"
          class="pdf-options-formfield"
        >
          <form-radio-button
            :id="`${quoteNamespace}_rbCustomer`"
            :title="i18n.t('/PrintOptions/Customer')"
            :disabled="!hasCustomer || !isEditable"
          >
            <input
              :id="`${quoteNamespace}_rbCustomer`"
              v-model="pContractor"
              :name="`${quoteNamespace}_rbCustomer`"
              value="customer"
              type="radio"
              :disabled="!hasCustomer || !isEditable"
              @change="handleChangeContractor"
            />
          </form-radio-button>
          <form-radio-button
            :id="`${quoteNamespace}_rbOrganisation`"
            :title="i18n.t('/PrintOptions/Organisation')"
            :disabled="!hasCustomerCompany || !isEditable"
          >
            <input
              :id="`${quoteNamespace}_rbOrganisation`"
              v-model="pContractor"
              :name="`${quoteNamespace}_rbOrganisation`"
              type="radio"
              value="organisation"
              :disabled="!hasCustomerCompany || !isEditable"
              @change="handleChangeContractor"
            />
          </form-radio-button>
          <form-radio-button
            :id="`${quoteNamespace}_rbLeaseCompany`"
            :title="i18n.t('/PrintOptions/LeaseCompany')"
            :disabled="!hasLeaseCompany || !isEditable"
          >
            <input
              :id="`${quoteNamespace}_rbLeaseCompany`"
              v-model="pContractor"
              :name="`${quoteNamespace}_rbLeaseCompany`"
              type="radio"
              value="leasecompany"
              :disabled="!hasLeaseCompany || !isEditable"
              @change="handleChangeContractor"
            />
          </form-radio-button>
        </app-form-field>

        <app-form-field
          :id="`${quoteNamespace}_pdfOptionsContactInfo`"
          :title="i18n.t('/PrintOptions/OtherCustomerInfoLabel')"
          class="pdf-options-formfield"
        >
          <form-checkbox
            :id="`${quoteNamespace}_contact-info-customer`"
            :title="i18n.t('/PrintOptions/CustomerDriver')"
            :disabled="!hasCustomer || pContractor == 'customer' || !isEditable"
          >
            <input
              :id="`${quoteNamespace}_contact-info-customer`"
              v-model="pContactInfo"
              name="contact-info-customer"
              value="customer"
              type="checkbox"
              :disabled="!hasCustomer || pContractor == 'customer' || !isEditable"
              @change="handleChangeContactInfo"
            />
          </form-checkbox>
          <form-checkbox
            :id="`${quoteNamespace}_contact-info-organisation`"
            :title="i18n.t('/PrintOptions/Organisation')"
            :disabled="!hasCustomerCompany || pContractor == 'organisation' || !isEditable"
          >
            <input
              :id="`${quoteNamespace}_contact-info-organisation`"
              v-model="pContactInfo"
              value="organisation"
              name="contact-info-organisation"
              type="checkbox"
              :disabled="!hasCustomerCompany || pContractor == 'organisation' || !isEditable"
              @change="handleChangeContactInfo"
            />
          </form-checkbox>
          <form-checkbox
            :id="`${quoteNamespace}_contact-info-leasecompany`"
            :title="i18n.t('/PrintOptions/LeaseCompany')"
            :disabled="!hasLeaseCompany || pContractor == 'leasecompany' || !isEditable"
          >
            <input
              :id="`${quoteNamespace}_contact-info-leasecompany`"
              v-model="pContactInfo"
              value="leasecompany"
              name="contact-info-leasecompany"
              type="checkbox"
              :disabled="!hasLeaseCompany || pContractor == 'leasecompany' || !isEditable"
              @change="handleChangeContactInfo"
            />
          </form-checkbox>
        </app-form-field>
      </app-fieldset>
    </form>
    <alert v-if="!pContractor" type="warning" text="Selecteer tenminste 1 contractant" />
  </div>
</template>

<script>
import AppFormField from '@/components/generic/presentational/atoms/formField/FormField.vue'
import AppFieldset from '@/components/generic/presentational/atoms/appFieldset/AppFieldset.vue'
import FormRadioButton from '@/components/generic/presentational/atoms/formRadioButton/FormRadioButton.vue'
import FormCheckbox from '@/components/generic/presentational/atoms/formCheckbox/FormCheckbox.vue'
import Alert from '@/components/generic/presentational/atoms/alert/Alert.vue'
import { EventBus } from '@/plugins/event-bus'
import axios from 'axios'
import { mapState } from 'vuex'
import AdditionalOrder from '@/mixins/additionalOrder.js'
import StoreConnector from '@/helpers/StoreConnector'

export default {
  components: {
    AppFormField,
    FormRadioButton,
    FormCheckbox,
    AppFieldset,
    Alert,
  },
  mixins: [AdditionalOrder],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      isEditable: true,

      pContractor: '',
      pContactInfo: [],
    }
  },
  computed: {
    // Dynamic namespaces aren't supported by mapGetters
    ...mapState({
      state(state) {
        return state[this.quoteNamespace]
      },
      quoteId(state, getters) {
        return getters[this.quoteNamespace + '/quoteId']
      },
      hasCustomer(state, getters) {
        return getters[this.quoteNamespace + '/hasCustomer']
      },
      hasCustomerCompany(state, getters) {
        return getters[this.quoteNamespace + '/hasCustomerCompany']
      },
      hasLeaseCompany(state, getters) {
        return getters[this.quoteNamespace + '/hasLeaseCompany']
      },
      hasOwner(state, getters) {
        return getters[this.quoteNamespace + '/hasOwner']
      },
      showVwpfsFinancePdf(state, getters) {
        return getters['quote/showVwpfsFinancePdf']
      },
      showVwpfsPrivateLeasePdf(state, getters) {
        return getters['quote/showVwpfsPrivateLeasePdf']
      },
      showVwpfsInsurancePdf(state, getters) {
        return getters['quote/showVwpfsInsurancePdf']
      },
      showVwpfsOperationalLeasePdf(state, getters) {
        return getters['quote/showVwpfsOperationalLeasePdf']
      },
    }),
  },
  created() {
    StoreConnector.get(`${this.quoteNamespace}/quoteStatusIsSalesOrder`, (data) => {
      this.isEditable = !data
    })
    // always select the last added contactType as contractor
    EventBus.$on('quote/companyUpdated', this.companyAdded)
    EventBus.$on('quote/customerUpdated', this.customerAdded)
    EventBus.$on('quote/leaseCompanyUpdated', this.leaseCompanyAdded)

    // if a contact type has been removed from the quote,
    // also remove it from the printOptions+contactInfo and disable the checkbox/radiobutton
    EventBus.$on('quote/companyRemoved', this.companyRemoved)
    EventBus.$on('quote/leaseCompanyRemoved', this.leaseCompanyRemoved)
    EventBus.$on('quote/customerRemoved', this.customerRemoved)

    const retrievedContactInfo =
      this.$store.getters[`${this.quoteNamespace}/printOptions/contactInfo`]
    const retrievedContractor =
      this.$store.getters[`${this.quoteNamespace}/printOptions/contractor`]

    if (retrievedContactInfo !== null && retrievedContactInfo !== undefined) {
      this.pContactInfo = retrievedContactInfo
    } else {
      this.pContactInfo = ['customer']
    }

    const isValidContractor =
      (retrievedContractor === 'customer' && this.hasCustomer) ||
      (retrievedContractor === 'organisation' && this.hasCustomerCompany) ||
      (retrievedContractor === 'leasecompany' && this.hasLeaseCompany)

    if (isValidContractor) {
      this.pContractor = retrievedContractor
    } else {
      this.pContractor = 'customer'
      this.autoSelectContractor()
      this.saveChanges()
    }
  },
  unmounted() {
    EventBus.$off('quote/companyUpdated', this.companyAdded)
    EventBus.$off('quote/customerUpdated', this.customerAdded)
    EventBus.$off('quote/leaseCompanyUpdated', this.leaseCompanyAdded)
    EventBus.$off('quote/companyRemoved', this.companyRemoved)
    EventBus.$off('quote/leaseCompanyRemoved', this.leaseCompanyRemoved)
    EventBus.$off('quote/customerRemoved', this.customerRemoved)

    StoreConnector.dispatch(`${this.quoteNamespace}/printOptions/reset`)
  },
  methods: {
    handleChangeContractor() {
      StoreConnector.commit(`${this.quoteNamespace}/printOptions/setContractor`, this.pContractor)
      this.handleChangeContactInfo()
    },
    handleChangeContactInfo() {
      // remove contactinfo which equals contractor, or which contactType is not on the quote (anymore)

      let newContactInfo = this.pContactInfo.filter((x) => x !== this.pContractor)
      if (!this.hasCustomer) newContactInfo = newContactInfo.filter((x) => x !== 'customer')
      if (!this.hasCustomerCompany)
        newContactInfo = newContactInfo.filter((x) => x !== 'organisation')
      if (!this.hasLeaseCompany) newContactInfo = newContactInfo.filter((x) => x !== 'leasecompany')

      StoreConnector.commit(`${this.quoteNamespace}/printOptions/setContactInfo`, newContactInfo)
      if (this.isEditable) this.saveChanges()
    },
    saveChanges() {
      const pdfOptions = {
        quoteId: this.quoteId,
        printContractorOnOrder: this.pContractor,
        printContactInfoOnPdf: this.pContactInfo,
        showVwpfsFinancePdf: this.showVwpfsFinancePdf,
        showVwpfsPrivateLeasePdf: this.showVwpfsPrivateLeasePdf,
        showVwpfsInsurancePdf: this.showVwpfsInsurancePdf,
        showVwpfsOperationalLeasePdf: this.showVwpfsOperationalLeasePdf,
      }
      this.$store
        .dispatch(`${this.quoteNamespace}/savePrintOptions`, pdfOptions)
        .then((response) => {
          return Promise.resolve(response)
        })
        .catch((e) => {
          if (axios.isCancel(e)) {
            return
          }
        })
    },
    autoSelectContractor() {
      // autoselect contractor. Priority: Leasecompany, organisation, customer
      if (this.hasLeaseCompany) this.pContractor = 'leasecompany'
      else if (this.hasCustomerCompany) this.pContractor = 'organisation'
      else if (this.hasCustomer) this.pContractor = 'customer'
    },
    customerRemoved() {
      if (this.pContractor === 'customer') {
        this.autoSelectContractor()
      }
      this.handleChangeContractor()
    },
    companyRemoved() {
      if (this.pContractor === 'organisation') {
        this.autoSelectContractor()
      }
      this.handleChangeContractor()
    },
    leaseCompanyRemoved() {
      if (this.pContractor === 'leasecompany') {
        this.autoSelectContractor()
      }
      this.handleChangeContractor()
    },
    customerAdded() {
      this.pContractor = 'customer'
      this.handleChangeContractor()
    },
    companyAdded() {
      this.pContractor = 'organisation'
      this.handleChangeContractor()
    },
    leaseCompanyAdded() {
      this.pContractor = 'leasecompany'
      this.handleChangeContractor()
    },
  },
}
</script>

<style lang="scss" scoped>
h5 {
  width: 100%;
}
.pdf-options {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}

.pdf-options-row {
  width: 100%;
}

.pdf-options-formfield {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
}

.pdf-front-page :deep(.fields) {
  grid-template-columns: 1fr 1fr;
}

.pdf-options-formfield .radio-button {
  margin-top: auto;
  display: block;
}
</style>
